/**
 * @typedef {import('../types').IDatasetRequestProps} IDatasetRequestProps
 */

export class ProjectDatasetRequestRepositoryClass {
    /**
     * @type {Map<string, IDatasetRequestProps>}
     * @private
     */
    _datasetRequestsMap = new Map();

    /**
     * @return {[string, IDatasetRequestProps][]}
     */
    get() {
        return [...this._datasetRequestsMap.entries()];
    }

    /**
     * @param {string} datasetRequestKey
     * @return {IDatasetRequestProps}
     */
    getById(datasetRequestKey) {
        return this._datasetRequestsMap.get(datasetRequestKey);
    }

    /**
     * @param {[string, IDatasetRequestProps][]} datasetRequestEntries
     * @return {ProjectDatasetRequestRepositoryClass}
     */
    set(datasetRequestEntries) {
        this._datasetRequestsMap = new Map(datasetRequestEntries);
        return this;
    }
}

export const ProjectDatasetRequestRepository = new ProjectDatasetRequestRepositoryClass();
